<!-- 点评详情 -->
<template>
  <div class="flex-page" data-test="course-comment-deatil">
    <template>
      <div class="main">

          <div class="b1">
            <div  v-if="detail.studentName" class="base van-hairline--bottom">
              <div class="base-l">{{ detail.studentName.slice(-2) }}</div>
              <div class="base-r">
                <div>
                  {{ detail.studentName }}&nbsp;<span class="desc"
                    >
                    <!-- 的"课堂"表现 -->
                    </span
                  >
                </div>
                <div class="time">
                  {{ detail.createTime | formatGoodDate() }}
                </div>
              </div>
            </div>
            <div class="class-info">
              <div class="class-info-item" >
                {{ detail.className }}&nbsp;{{
                  detail.classTime.date | formatDatetime(new Date(detail.classTime.date).getFullYear()===new Date().getFullYear()?'MM月dd日':'yyyy年MM月dd日')
                }}({{ detail.classTime.weekdayName }})&nbsp;{{
                  detail.classTime.startTime
                }}～{{ detail.classTime.endTime }}
              </div>
              <div class="class-info-item">
                点评人：{{ app.teacher.user.name }}
              </div>
              <div class="class-info-item">
                表现评分：<van-rate
                  v-model="detail.score"
                  void-icon="star"
                  size="var(--fs-md)"
                  void-color="var(--g4)"
                  color="var(--c4)"
                  :readonly="true"
                />
              </div>
            </div>
            <div class="comment-title">
              {{ detail.commentTitle }}
            </div>
            <vx-mult-input-show
              :list="detail.commentContent.list"
            ></vx-mult-input-show>
          </div>
      </div>
    </template>
  </div>
</template>

<script>

import card from '@teacher/views/base/comment/course-comment/children/qanda-card.vue';

export default {
  name: "comment-detail",
  mixins: [app.mixin.share],
  components:{
    card,
  },
  data() {
    return {
      pageTitle: "点评预览",
      myId: app.teacher.user.id,
      commentId: "",
      detail: {},
      // 回复列表
      replyList: [],
      allReplyNum: 0,
      api: this.$api.getCommentReplyRecordPage,
      params: {
        commentRecordId: this.$route.params.id,
      },
      // 显示评论输入框
      showinput: false,
      // 回复框占位文本
      replyPlaceholder: "",
      // 回复谁
      replied: "",
      repliedName: "",
      repliedType: "",
      // 要提交的回复的内容
      replyContent: "",
      showOpMark: false,

      qandaParams:{},

      shareParams: {},
    };
  },
  computed: {
    OpMarkActions() {
      // 若视频还在合成，则：1、仅支持“删除”操作
      let actions = [];
      if (this.detail.contentGlobalStatus == 2) { // contentGlobalStatus：1 合成中 2已合成 3合成失败（含失败的会优先合成失败）
        actions = actions.concat([{
          name: "分享",
          id: -1,
        },{
          name: "生成海报",
          id: -2,
        }]);
      }
        if (app.permission.op('edit_course_comment') && this.detail.contentGlobalStatus !== 1) {
          actions.push({name: "编辑",id: 1});
        }
        if (app.permission.op('delete_course_comment')) {
          actions.push({name: "删除",id: 0});
        }
      return actions;
    },
    showQanda(){
      return this.detail && (this.detail.reviewEnable == 1) && (this.detail.reviewStatus == 2) && (this.detail.commentSet.showFromTeacher == 1);
    }
  },
  methods: {
    onload(list, res) {
      this.replyList = list;
      this.allReplyNum = res.page.totalCount;
    },
    render() {
      this.detail = app.ls.get('comment-c-preview')?JSON.parse(app.ls.get('comment-c-preview')):{}
    },
  },
  created() {
    this.render();
  },
};
</script>

<style lang="scss" scoped>
.flex-page {
  display: flex;
  flex-direction: column;
}
.main {
  flex: 1;
}
.inp-wrap {
  background: var(--white);
  &.fixed-inp-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    &.active {
      z-index: 2;
    }
  }
  // 重写输入框样式
  ::v-deep .van-cell {
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    .van-field__control {
      height: calc(var(--w) * 44);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      border-radius: calc(var(--w) * 44);
      background-color: var(--g2);
      padding: 0 calc(var(--w) * 24);
    }
  }
  .btn {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    padding: calc(var(--gap) * 5);
    &.btn1 {
      color: var(--c1);
    }
    &.btn2 {
      color: var(--g5);
    }
  }
}
.b1 {
  padding: 0 16px 16px 16px;
  background-color: var(--white);
  .base {
    padding: calc(var(--gap) * 16) 0;
    display: flex;
    .base-l {
      display: inline-block;
      width: calc(var(--w) * 40);
      height: calc(var(--w) * 40);
      line-height: calc(var(--w) * 40);
      border-radius: 50%;
      background-color: var(--c1);
      color: var(--white);
      text-align: center;
      vertical-align: middle;
      margin-right: calc(var(--gap) * 8);
    }
    .base-r {
      flex: 1;
      position: relative;
      .desc {
        color: var(--g6);
      }
      .time {
        margin-top: calc(var(--gap) * 2);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        color: var(--g6);
      }
      .op-img {
        position: absolute;
        right: 0;
        width: calc(var(--w) * 16);
        height: calc(var(--w) * 16);
        padding: calc(var(--gap) * 5);
        margin: auto 0;
        top: calc(var(--w) * 7);
      }
    }
  }
  .class-info {
    padding-bottom: calc(var(--gap) * 12);
    color: var(--g6);
    .class-info-item {
      padding-top: calc(var(--gap) * 12);
      .van-rate {
        vertical-align: middle;
      }
    }
  }
  .comment-title{
    font-size:16px;
    font-weight:600;
    margin-top:8px;
    margin-bottom:10px;
  }
}

.b2 {
  margin-top: calc(var(--gap) * 12);
  background-color: var(--white);
  padding: 0 calc(var(--gap) * 16);
  .til {
    display: flex;
    align-items: center;
    padding: calc(var(--gap) * 16) 0;
    .t1 {
      font-size: var(--fs-lg);
      // line-height: var(--lh-lg);
      font-weight: bold;
    }
    .t2 {
      font-size: var(--fs-sm);
      // line-height: var(--lh-sm);
      font-weight: normal;
    }
  }
  .reply {
    display: flex;
    padding-bottom: calc(var(--gap) * 24);
    .pho {
      margin-top: calc(var(--gap) * 4);
      margin-right: calc(var(--gap) * 8);
      width: calc(var(--w) * 40);
      height: calc(var(--w) * 40);
      border-radius: calc(var(--w) * 40);
      background: #000;
    }
    .info {
      flex: 1;
      .l1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .l1l {
          color: var(--g7);
          font-size: var(--fs-md);
          line-height: var(--lh-md);
        }
        .l1r {
          padding: calc(var(--gap) * 4);
        }
        .r1 {
          color: var(--g8);
        }
        .r2 {
          color: var(--c3);
        }
        .icon {
          margin-right: calc(var(--gap) * 2);
        }
      }
      .l2 {
        color: var(--g6);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
      }
      .l3 {
        padding-top: calc(var(--gap) * 8);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        color: var(--g8);
        white-space:normal; 
        word-break:break-all;
        .l31 {
          color: var(--g6);
        }
      }
    }
  }
}

// }
</style>